<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h1 class="text-center mb-3" v-html="$t('PreProgram.SplashTitle')">
      </h1>
      <p v-html="$t('PreProgram.SplashDescription')"></p>


    </div>
  </main>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
<style scoped>
.navbar-nav {
  display: none;
}
</style>
